import { render, staticRenderFns } from "./TourismMain.vue?vue&type=template&id=731bdf06&scoped=true&"
import script from "./TourismMain.vue?vue&type=script&lang=js&"
export * from "./TourismMain.vue?vue&type=script&lang=js&"
import style0 from "./TourismMain.vue?vue&type=style&index=0&id=731bdf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731bdf06",
  null
  
)

export default component.exports